module.exports = __webpack_public_path__ + "code.svg?81006feecbbdf7248ecef124c39f69a6";